import { PageToolbar } from '#/components/PageToolbar/PageToolbar';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { OrgDashboardApiOrg } from '#/modules/orgDashboard/api/types/OrgDashboardApiOrg';

import { ActionButtons } from './ActionButtons';

type Props = {
  org: OrgDashboardApiOrg;
  isPublished?: boolean;
  editMode: boolean;
  setEditMode: (setMode: boolean) => void;
};

export function ViewOrgToolbar({
  org,
  isPublished,
  editMode,
  setEditMode,
}: Props) {
  const { i18n } = useI18n();

  return (
    <PageToolbar
      centered
      message={
        org.isFrozen
          ? i18n(
              'Your organization has been frozen. Please contact the Idealist Community Support Team to resolve this issue.',
            )
          : i18n('You are an administrator of this organization')
      }
      tools={
        <ActionButtons
          org={org}
          isPublished={isPublished}
          editMode={editMode}
          setEditMode={setEditMode}
        />
      }
    />
  );
}
